import React from "react";
import {Col, Container, Row} from "react-bootstrap";

import {buildUrl} from '../service/url-builder';
import {LoadingDisplay} from "./LoadingDisplay";
import {SummarySelectors} from "./SummarySelector";
import {SummaryList} from "./SummaryList";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";
const axios = require('axios');

class RoutedSummary extends React.Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        let queryArgs = new URLSearchParams(props.location.search);
        let defaultConfig = queryArgs.get('configName');

        this.state = {
            "runContext" : this.props.match.params.runContext,
            "configName" : defaultConfig,
            "dailySummaryData" : [],
            "configList" : [],
            "summaryConfig" : {},
            formState :{dirty: true, loading: false},
        }
        this.formChanged = this.formChanged.bind(this);
    }

    fetchSummaryData(runContext, configName){
        const summaryRequest = axios.get(buildUrl("/dailySummary"), {
            params: {
                configName: configName,
                runContext: runContext
            }
        });
        this.setState({formState :{dirty: true, loading: true}});
        axios.all([summaryRequest]).then(axios.spread((...responses) => {
            const summaryRequest = responses[0];
            let config = {};
            for(let i = 0; summaryRequest.data.length; i++){
               if(summaryRequest.data[i].config){
                   config = summaryRequest.data[i].config;
                   break;
               }
            }
            this.setState( { "summaryConfig" : config,
                "dailySummaryData" : summaryRequest.data,
                formState :{dirty: false, loading: false}});
        })).catch(errors => {
            console.log("Oops something when wrong.");
        })
    }

    componentDidMount() {
        if(this.state.configName === null){
            console.log("no default found");
        }else{
            this.fetchSummaryData(this.state.runContext, this.state.configName);
        }

    }

    formChanged(data){
        this.setState(
            {
                configName : data.value,
                formState: {dirty: true, loading: false},
            })
        this.fetchSummaryData(this.state.runContext, data.value);
    }

    render() {
        return (
            <Container style={{'margin':'10px 0'}}>
                <Row>
                    <Col>
                        <SummarySelectors runContext={this.state.runContext} changedHandler={this.formChanged} configValue={this.state.configName}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div>Run Context:{this.state.runContext} - config: {this.state.summaryConfig.name}</div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <LoadingDisplay loading={this.state.formState.loading}/>
                        <SummaryList summaryData={this.state.dailySummaryData}/>
                    </Col>
                </Row>
            </Container>
        );
    }
}
const Summary = withRouter(RoutedSummary)
export {Summary}
